import React from "react";

const Services = () => {
  // services details
  const services = [
    // {
    //   name: "Graphic Design",
    //   desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
    //   icon: "fas fa-palette",
    // },

    {
      name: "Business Analysis",
      desc: "I combine technical understanding with business strategy to align teams around a shared vision. From gathering requirements to mapping workflows and defining KPIs, I focus on ensuring every feature and process contributes to measurable business outcomes.",
      icon: "fas fa-chart-area",
    },
    {
      name: "UI/UX Design",
      desc: "I design digital experiences that balance beauty and usability. From wireframes to polished interfaces, I combine design systems, accessibility principles, and interaction patterns to craft products that make people’s lives easier — and brands stand out.",
      icon: "fas fa-pencil-ruler",
    },
    {
      name: "Web Development",
      desc: "I specialize in building modern web solutions using cutting-edge frameworks and clean, scalable architectures. From pixel-perfect UIs to API-driven systems, I bring together design, performance, and innovation to create products that stand out in both form and function.",
      icon: "fas fa-desktop",
    },
    {
      name: "Front End Architecture",
      desc: "A well-designed front-end architecture sets the tone for everything that follows. I specialize in crafting efficient, modular systems that balance speed, scalability, and seamless user experiences — ensuring every project remains adaptable as technology evolves.",
      icon: "fas fa-code",
    },
    {
      name: "Backend Development",
      desc: "Behind every great app is a solid backend. I build robust server-side solutions using modern technologies, clean architecture principles, and optimized data handling — ensuring applications remain fast, reliable, and ready for scale.",
      icon: "fas fa-server",
    },
    {
      name: "Testing and Debugging",
      desc: "Quality code means fewer surprises. I use modern testing frameworks and smart debugging techniques to identify issues early, optimize performance, and keep projects running smoothly from development to deployment.",
      icon: "fas fa-bug",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
